/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

// Bundle-side helper for catalog/top-search modules.
// Keep logic aligned with view/frontend/templates/storefront-context-helpers-js.phtml for inline scripts.

export const STOREFRONT_REQUIRED_FIELDS = [
    'environmentId',
    'environment',
    'storeUrl',
    'websiteId',
    'storeId',
    'storeViewId',
    'websiteName',
    'storeName',
    'storeViewName',
    'baseCurrencyCode',
    'storeViewCurrencyCode'
]

/**
 * Validate required storefront fields for Adobe schemas.
 *
 * @param {Object} storefrontCtx
 * @returns {boolean}
 */
export const hasRequiredStorefrontFields = (storefrontCtx) => STOREFRONT_REQUIRED_FIELDS.every((field) => {
    const value = storefrontCtx?.[field]

    if (typeof value === 'number') {
        return Number.isFinite(value)
    }

    return typeof value === 'string' && value.trim() !== ''
})

/**
 * Merge storefront context, prioritizing valid preferred values.
 *
 * @param {Object} currentStorefrontCtx
 * @param {Object} preferredStorefrontCtx
 * @returns {Object}
 */
export const mergeStorefrontCtx = (currentStorefrontCtx, preferredStorefrontCtx) => {
    const mergedStorefrontCtx = {
        ...(currentStorefrontCtx || {})
    }

    Object.entries(preferredStorefrontCtx || {}).forEach(([key, value]) => {
        if (typeof value === 'number' && Number.isFinite(value)) {
            mergedStorefrontCtx[key] = value
            return
        }

        if (typeof value === 'string' && value.trim() !== '') {
            mergedStorefrontCtx[key] = value
            return
        }

        if (value === null) {
            mergedStorefrontCtx[key] = null
        }
    })

    return mergedStorefrontCtx
}
